export const FEATURE_NAME = '@zerops/zui/notification-item';
